import { render, staticRenderFns } from "./PageRecipes.vue?vue&type=template&id=0153fe17&"
import script from "./PageRecipes.vue?vue&type=script&lang=js&"
export * from "./PageRecipes.vue?vue&type=script&lang=js&"
import style0 from "./PageRecipes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports